"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mixPanelSubscriber;

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

var _helpers = require("../helpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function mixPanelSubscriber(digitalDataEvent, config) {
  var mixpanelToken = config.mixpanelToken,
      user = config.user;
  var name = digitalDataEvent.name,
      digitalData = digitalDataEvent.data;

  var actionType = digitalData.actionType,
      actionFlow = digitalData.actionFlow,
      data = _objectWithoutProperties(digitalData, ["actionType", "actionFlow"]);

  if (!mixpanelToken) {
    return;
  }

  if (!actionType || !actionFlow) {
    return;
  }

  var userId = user.id,
      isAuthenticated = user.isAuthenticated,
      username = user.username,
      languageId = user.languageId,
      _package = user.package,
      email = user.email;

  _mixpanelBrowser.default.init(mixpanelToken);

  if (isAuthenticated) {
    _mixpanelBrowser.default.identify(userId);

    _mixpanelBrowser.default.people.set({
      $name: (0, _helpers.maskString)(username),
      $email: (0, _helpers.maskEmail)(email),
      languageId: languageId,
      package: _package
    });
  }

  _mixpanelBrowser.default.track(name, _objectSpread({
    actionType: actionType,
    actionFlow: actionFlow
  }, data));
}

module.exports = exports.default;